// JobberForm.js
import React, { useEffect } from 'react';

const FormJobber = ({ clientId }) => {
  useEffect(() => {
    // Dynamically load the Jobber form script
    const loadScript = (src, id, formUrl) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('clienthub_id', id);
      script.setAttribute('form_url', formUrl);
      document.body.appendChild(script);
      return script;
    };

    // Dynamically load the Jobber form stylesheet
    const loadStyles = (href) => {
      const link = document.createElement('link');
      link.href = href;
      link.rel = 'stylesheet';
      link.media = 'screen';
      document.head.appendChild(link);
      return link;
    };

    const script = loadScript(
      'https://d3ey4dbjkt2f6s.cloudfront.net/assets/static_link/work_request_embed_snippet.js',
      clientId,
      `https://clienthub.getjobber.com/client_hubs/${clientId}/public/work_request/embedded_work_request_form`
    );

    const link = loadStyles(
      'https://d3ey4dbjkt2f6s.cloudfront.net/assets/external/work_request_embed.css'
    );

    // Cleanup function to remove script and link from the DOM when the component unmounts
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, [clientId]);

  return <div id={clientId} />;
};

export { FormJobber };
